<template>
    <div class="Report" app>
        <Navbar />
        <v-content>
            <v-dialog
                v-model="erro_dialog"
                max-width="500"
            >
                <v-card :dark="customization.dark">
                    <v-card-title class="headline">Erro!</v-card-title>
                    <v-card-text>
                        Todos os campos precisam ser preenchidos!
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            :color="customization.dark ? 'white' : 'black'"
                            text
                            @click="erro_dialog = false"
                        >
                            Fechar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <div style="margin: 10px 16px;">
                <v-card style="overflow-x:hidden" flat :dark="customization.dark">
                    <v-card-title>Emissão de relatórios</v-card-title>
                    <v-row style="padding: 0px 16px">
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                label="Data de inicio"
                                v-model="data_inicio"
                                name="data_inicio"
                                :rules="requireRule"
                                type="date"
                                outlined >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                label="Data de Fim"
                                v-model="data_final"
                                name="data_final"
                                :rules="requireRule"
                                type="date"
                                outlined >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row style="padding: 0px 16px; transform: translateY(-25px)">
                        <v-col cols="12" sm="12" md="8">
                            <Autocomplete 
                                label="Turno"
                                name="turno"
                                :dark="customization.dark"
                                :required="true"
                                :needWhere="true"
                                url="getTurno"
                                iddisplay="descricao"
                                idvalue="idturno"
                                outlined >
                            </Autocomplete>
                        </v-col>
                    </v-row>
                    <v-row style="padding: 0px 16px; transform: translateY(-45px)">
                        <v-col cols="12" sm="6" md="4">
                             <v-select
                                v-model="cargas_selecionado"
                                :items="cargas_selecionado_items"
                                :color="customization.mainBtnColor"
                                :loading="loading_cargas"
                                chips
                                label="Cargas"
                                item-text="descricao"
                                item-value="idcarga"
                                multiple
                                outlined
                                return-object
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                             <v-select
                                v-model="situacoes_selecionado"
                                :items="situacoes_selecionado_items"
                                :color="customization.mainBtnColor"
                                :loading="loading_situacoes"
                                chips
                                label="Situações"
                                item-text="situacao"
                                item-value="idsituacao"
                                multiple
                                outlined
                                return-object
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row style="padding: 0px 16px; transform: translateY(-55px)">
                        <v-col cols="12" sm="6" md="4">
                            <v-card style="overflow-x:hidden" outlined :dark="customization.dark" :loading="caminhoes_loading">
                                <v-card-title style="padding: 0px 16px"> 
                                    <v-checkbox
                                        @change="selecionar_todos_c">
                                    </v-checkbox> Caminhões
                                </v-card-title>
                                <div style="height: 350px; overflow-y: auto">
                                    <v-card 
                                        style="overflow-x:hidden;" 
                                        outlined 
                                        :dark="customization.dark"
                                        v-for="c in caminhoes"
                                        :key="c.placa">
                                        <div style="padding: 8px 16px">
                                            <v-checkbox 
                                                :value="c.placa"
                                                v-model="caminhoes_ativo" 
                                                :label="c.placa">
                                            </v-checkbox>
                                        </div>
                                    </v-card>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-card style="overflow-x:hidden" outlined :dark="customization.dark" :loading="relatorios_loading">
                                <v-card-title style="padding: 0px 16px"> 
                                    <v-checkbox
                                        @change="selecionar_todos_t">
                                    </v-checkbox> Tipos de Relatórios
                                </v-card-title>
                                <div style="height: 350px; overflow-y: auto">
                                    <v-card 
                                        style="overflow-x:hidden;" 
                                        outlined 
                                        :dark="customization.dark"
                                        v-for="t in tipos_relatorios"
                                        :key="t.relatorio_url">
                                        <div style="padding: 8px 16px">
                                            <v-checkbox 
                                                :value="t.relatorio_url"
                                                v-model="tipos_relatorios_ativo" 
                                                :label="t.caption">
                                            </v-checkbox>
                                        </div>
                                    </v-card>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row style="padding: 0px 16px; transform: translateY(-55px)">
                        <v-col cols="12" sm="12" md="6" lg="8">
                            <v-card style="overflow-x:hidden" outlined :dark="customization.dark">
                                <v-card-title style="padding: 12px 16px"> 
                                    Tipos de Veiculos
                                </v-card-title>
                                <v-btn-toggle
                                    style="width: 100%"
                                    v-model="prod"
                                    borderless
                                >
                                    <v-btn value="false" style="width: 33%" color="transparent">
                                        <span>Sem produção</span>
                                    </v-btn>

                                    <v-btn value="null" style="width: 34%" color="transparent">
                                        <span>Ambos</span>
                                    </v-btn>

                                    <v-btn value="true" style="width: 33%" color="transparent">
                                        <span>Com produção</span>
                                    </v-btn>
                                </v-btn-toggle>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row style="padding: 0px 16px; transform: translateY(-50px)">
                        <v-col cols="12">
                            <v-btn
                                large
                                :color="customization.mainBtnColor"
                                :dark="customization.mainBtnDark"
                                @click="emitir">
                                Emitir Relatório
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </div>
        </v-content>
    </div>
</template>

<script>
import Autocomplete from '@/components/Autocomplete.vue';
import Navbar       from '@/components/Navbar.vue';
import api          from '@/plugins/apisauceHeader.js';
import router       from '@/router/index.js';

export default {
    name: 'CRUD',
    components:{
        Navbar,
        Autocomplete
    },
    data: () => ({
        customization: {},
        data_inicio: null,
        data_final: null,
        caminhoes: [],
        caminhoes_ativo: [],
        tipos_relatorios: [],
        tipos_relatorios_ativo: [],
        caminhoes_loading: true,
        relatorios_loading: true,
        erro_dialog: false,
        prod: "null",
        requireRule:[
            r => (r && r.length > 0 ) || "Essa campo é obrigatório!"
        ],
        selecionar_todos_caminhoes: false,
        selecionar_todos_tipo: false,
        cargas_selecionado: [],
        situacoes_selecionado: [],
        loading_cargas: true,
        cargas_selecionado_items: [],
        situacoes_selecionado_items: [],
        loading_situacoes: true,
    }),
    methods: {
        addCarga(e){
            this.cargas_selecionado.push({
                id: e.model.idcarga,
                label: e.model.descricao
            })
        },
        remCarga(i){
            this.cargas_selecionado.splice(i,1);
        },
        addSituacoes(e){
            this.situacoes_selecionado.push({
                id: e.model.idsituacao,
                label: e.model.situacao
            })
        },
        remSituacoes(i){
            this.situacoes_selecionado.splice(i,1);
        },
        selecionar_todos_c(e){
            this.caminhoes_ativo = e ? this.caminhoes.map(r=>{return r.placa}) : [];
        },
        selecionar_todos_t(e){
            this.tipos_relatorios_ativo = e ? this.tipos_relatorios.map(r=>{return r.relatorio_url}) : [];
        },
        emitir(){
            const dataInicio =  this.data_inicio;
            if(!dataInicio)     document.getElementsByName("data_inicio")[0].focus();
            const dataFinal  =  this.data_final;
            if(!dataFinal)      document.getElementsByName("data_final")[0].focus();
            const caminhoes  =  this.caminhoes_ativo;
            const tipos      =  this.tipos_relatorios_ativo;
            const carga      =  this.cargas_selecionado.map(c=>{
                return `${c.idcarga}_${c.descricao}`;
            });
            const situacoes   =  this.situacoes_selecionado.map(c=>{
                return `${c.idsituacao}_${c.situacao}`;
            });
            const turno      =  document.getElementsByName("turno")[0].value;
            if(turno == "")     this.erro_dialog = true;

            if(tipos.length <= 0) this.erro_dialog = true;
            if(caminhoes.length <= 0) this.erro_dialog = true;

            if(!dataInicio || !dataFinal || turno == "" || tipos.length <= 0 ||  caminhoes.length <= 0) return;

            let url = `relatorio/addwhere=idcliente:${localStorage.getItem("idcliente")},fuso:${-(new Date().getTimezoneOffset() / 60)}`;
            if(turno) url += `,idturno:${turno}`;
            if(carga.length > 0) url += `,idcarga:[${carga.join(",")}]`;
            if(dataInicio) url += `,datainicial:${dataInicio}`;
            if(dataFinal) url += `,datafinal:${dataFinal}`;
            if(caminhoes.length <= 0) this.erro_dialog = true;
            if(tipos.length <= 0) this.erro_dialog = true;
            url += `,placa:{${caminhoes.map(c=>{return `''${c}''`}).join(",")}}`;
            if(situacoes.length > 0) url += `,idsituacao:[${situacoes.join(",")}]`;

            let tabs = tipos.join(",");
            url += `/tabs=[${tabs}]/${localStorage.getItem("system")}?noPagination=true`;

            if(this.prod != "null") url += `&prod_veiculos=${this.prod}`;
            window.open(api(localStorage.getItem("token")).getBaseURL() + url,"_blank");
        }
    },
    mounted(){
        if(!localStorage.getItem("usrId")) router.push('/');
        this.customization = JSON.parse(localStorage.getItem("customization"));
        document.title = `${this.customization.name} - Relatórios`;
        api(localStorage.getItem("token")).get(`endpoint/veiculo/addwhere=idcliente:${localStorage.getItem("idcliente")}?noPagination=true`).then(r=>{
            if(r.ok)
                this.caminhoes = r.data.endpoint;

            this.caminhoes_loading = false;
        });
        api(localStorage.getItem("token")).get("endpoint/tipo_relatorio/addwhere=tipo:1?noPagination=true").then(r=>{
            if(r.ok)
                this.tipos_relatorios = r.data.endpoint;

            this.relatorios_loading = false;
        });
        api(localStorage.getItem("token")).get(`endpoint/getCargaSelecionada/addwhere=idcliente:${localStorage.getItem("idcliente")}?noPagination=true`).then(r=>{
            if(r.ok)
                this.cargas_selecionado = r.data.endpoint;
        });
        api(localStorage.getItem("token")).get(`endpoint/getSituacoesSelecionada/addwhere=idcliente:${localStorage.getItem("idcliente")}?noPagination=true`).then(r=>{
            if(r.ok)
                this.situacoes_selecionado = r.data.endpoint;
        });
        api(localStorage.getItem("token")).get(`endpoint/getCarga/addwhere=idcliente:${localStorage.getItem("idcliente")}?noPagination=true`).then(r=>{
            if(r.ok)
                this.cargas_selecionado_items = r.data.endpoint;

            this.loading_cargas = false;
        });
        api(localStorage.getItem("token")).get(`endpoint/situacaoSOS/addwhere=idcliente:${localStorage.getItem("idcliente")}?noPagination=true`).then(r=>{
            if(r.ok)
                this.situacoes_selecionado_items = r.data.endpoint;

            this.loading_situacoes = false;
        });
    }
}
</script>